module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/academy/adriti@1x.svg"